import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CategoriesEffects } from './categories-effects';
import { CategoriesHttpClient } from './categories-http-client';
import { categoriesFeature } from './categories-reducer';

@NgModule({
  imports: [StoreModule.forFeature(categoriesFeature), EffectsModule.forFeature([CategoriesEffects])],
  providers: [CategoriesHttpClient],
})
export class CategoriesStoreModule {}
